<mat-form-field [formGroup]="formGroup" appearance="outline" fxFlex>
    <mat-label >Marca/Modelo</mat-label>
    <input #cdMarcaVeiculo type="text" id="cdMarcaVeiculo" matInput placeholder="Marca/Modelo" 
           formControlName="marcaModelo" [matAutocomplete]="autoMarcaModelo" 
           (input)="cdMarcaVeiculo.value=$event.target.value.toUpperCase()"/>
    <mat-autocomplete #autoMarcaModelo="matAutocomplete" [displayWith]="displayFn" panelWidth="auto"
          (optionSelected)="marcaModeloSelecionado($event)">
        <mat-option *ngFor="let marcaModelo of marcaModelosFiltrados" [value]="marcaModelo">
          {{marcaModelo.nmModelo}}
        </mat-option>
    </mat-autocomplete>
    <mat-icon matPrefix>search</mat-icon>
  </mat-form-field>